import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { setIn } from 'final-form';

/**
 * yup schema validator.
 *
 * @author Mikhail Siutsou
 * @function validator
 * @category helper
 * @param {BaseSchema} schema validation form.
 * @return {ValidationErrors | Promise<ValidationErrors>) | undefined} validation errors.
 */
function validator(schema) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      var catchError;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return schema.validate(values, {
                abortEarly: false
              });

            case 3:
              _context.next = 9;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              catchError = _context.t0;
              return _context.abrupt("return", catchError.inner.reduce(function (errors, error) {
                return setIn(errors, error.path, error.message);
              }, {}));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

export { validator };